import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const Container = styled.div(
    ({ theme }: ParamsStyle) => `
   width: 100%;
   height: 100vh;
   display: flex;
`);

export const ContainerBody = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    flex-direction: column;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        &.changed-payment {
            padding-bottom: 2.1875rem;
        }
    }
`);

export const ContentBody = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    flex-direction: column;
`);

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    max-width: 14rem;
    height: 13.1875rem;
    align-items: center;
    border-radius: 12px;
    margin-left: .875rem;
    margin-top: .9375rem;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${theme?.palette.primary.main};
`);

export const LinkCustom = styled.a(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    height: 65%;
    gap: .875rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-radius: 12px 12px 0 0;
    background-color: ${theme?.palette.primary.main};
`);
